// extracted by mini-css-extract-plugin
module.exports = {"divider":"WordRace_divider__1a8mO","wordsContainer":"WordRace_wordsContainer__3Fd8S","word":"WordRace_word__3B56L"};